<template>
  <div class="countdown">
    <div v-if="days" class="countdown__block">
      <div class="countdown__digit">{{ days | twoDigits }}</div>
      <div v-if="labels" class="countdown__text">Días</div>
    </div>
    <div class="countdown__block">
      <div class="countdown__digit">{{ hours | twoDigits }}</div>
      <div v-if="labels" class="countdown__text">Hrs</div>
    </div>
    <div class="countdown__block" >
      <div class="countdown__digit">{{ minutes | twoDigits }}</div>
      <div v-if="labels" class="countdown__text">Min</div>
    </div>
    <div class="countdown__block">
      <div class="countdown__digit">{{ seconds | twoDigits }}</div>
      <div v-if="labels" class="countdown__text">Seg</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    date: null,
    labels: {
      type: Boolean,
      default: false,
    },
    alertTimeMin: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      now: Math.trunc((new Date()).getTime() / 1000),
      finish: false,
      alert: false,
    };
  },
  mounted() {
    const self = this;
    const timer = window.setInterval(() => {
      this.now = Math.trunc((new Date()).getTime() / 1000);
      if (!this.finish && this.secondCount <= 0) {
        self.finish = true;
        self.$emit('onFinish');
        window.clearInterval(timer);
      }
      if (!this.alert && this.minutes < this.alertTimeMin && !this.hours && !this.days) {
        self.alert = true;
        self.$emit('onAlert', this.minutes);
      }
      if (this.secondCount > 0) {
        this.$emit('onSeconds', this.secondCount);
      }
    }, 1000);
  },
  computed: {
    secondCount() {
      return this.calculatedDate - this.now;
    },
    calculatedDate() {
      return Math.trunc(Date.parse(this.date) / 1000);
    },
    seconds() {
      if (this.secondCount < 0) return 0;
      return this.secondCount % 60;
    },
    minutes() {
      if (this.secondCount < 0) return 0;
      return Math.trunc(this.secondCount / 60) % 60;
    },
    hours() {
      if (this.secondCount < 0) return 0;
      return Math.trunc(this.secondCount / 60 / 60) % 24;
    },
    days() {
      if (this.secondCount < 0) return 0;
      return Math.trunc(this.secondCount / 60 / 60 / 24);
    },
  },
  filters: {
    twoDigits(value) {
      const val = value.toString();
      if (val.length <= 1) {
        return `0${val}`;
      }
      return val;
    },
  },
};
</script>
<style lang="scss">
.countdown{
  display: flex;
  &__block {
    text-align: center;
    padding: 0 10px;
    position: relative;
    &:first-child{
      padding-left: 0;
      .countdown__digit{
        &:before{
          display: none;
        }
      }
    }
    &:last-child{
      padding-right: 0;
    }
  }
  &__text {
    margin-bottom: 5px;
    font-size: 50%;
  }
  &__digit {
    font-weight: bold;
    line-height: 1;
    &:before{
      content: ":";
      position: absolute;
      left: -5px;
    }
  }
}
</style>
